export default __webpack_public_path__ + "static/media/G_Forms.9b338af3.png";